import React from 'react';
import { Banner, Gutter, ReadonlyTextarea } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

import { RejectionLossCodesUtil } from '../../utils/RejectionLossCodesUtil';

export type EngagementsHistoryViewStatusMessageBannerProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
};

export const EngagementsHistoryViewStatusMessageBanner: React.FC<
  EngagementsHistoryViewStatusMessageBannerProps
> = ({
  engagement,
  name = 'ENGAGEMENTS_HISTORY_VIEW_STATUS_MESSAGE_BANNER',
}) => {
  if (engagement.candidateStatusMessage) {
    return (
      <Gutter bottom="24px">
        <Banner name={name}>
          <ReadonlyTextarea
            value={engagement.candidateStatusMessage}
            formatting="modern"
          />
        </Banner>
      </Gutter>
    );
  }

  if (
    RejectionLossCodesUtil.hasRejectedByClientMessage(
      engagement.candidateStatus,
      engagement.rejectionLossCode
    )
  ) {
    return (
      <Gutter bottom="24px">
        <Banner name={name}>
          {RejectionLossCodesUtil.getRejectedByClientMessage(
            engagement.candidateStatus,
            engagement.rejectionLossCode
          )}
        </Banner>
      </Gutter>
    );
  }

  if (
    RejectionLossCodesUtil.hasRejectedDefaultMessage(
      engagement.rejectionLossCode
    )
  ) {
    return (
      <Gutter bottom="24px">
        <Banner name={name}>
          {RejectionLossCodesUtil.getRejectedDefaultMessage(
            engagement.rejectionLossCode
          )}
        </Banner>
      </Gutter>
    );
  }

  return null;
};
